var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTooltipButton',_vm._g({attrs:{"disabled":_vm.disabled,"class-button":['b-table-button-expand', { 'is-active': _vm.active }],"icon":"mdi-chevron-down","depressed":"","small":"","top":""}},_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }